export const SCOPE_AUTH = "/auth";
export const SCOPE_APP = "/app";
export const SCOPE_EXTERNAL = "/external";

export const ROOT_PATH_V1 = "/api/v1";
export const ROOT_PATH_V2 = "/api/v2";

// used for sully.ai clients only
export const APP_ROOT_V2 = `${ROOT_PATH_V2}${SCOPE_APP}`;
export const APP_ROOT_V1 = `${ROOT_PATH_V1}${SCOPE_APP}`;

// used by external API users only
export const EXTERNAL_ROOT_PATH_V2 = `${ROOT_PATH_V2}${SCOPE_EXTERNAL}`;

const WORK_OS = "workos";
const API_KEYS = "api-keys";
const WEBHOOKS = "webhooks";

export const DASHBOARD_ROOT_PATH_V1 = ROOT_PATH_V1;
export const DASHBOARD_ROOT_PATH_WORKOS = `${DASHBOARD_ROOT_PATH_V1}/${WORK_OS}`;
export const DASHBOARD_ROOT_PATH_API_KEYS = `${DASHBOARD_ROOT_PATH_V1}/${API_KEYS}`;
export const DASHBOARD_ROOT_PATH_WEBHOOKS = `${DASHBOARD_ROOT_PATH_V1}/${WEBHOOKS}`;

export const API_BASE_PATH = "/api";

/**
 * Stable app-relative paths shared by TanStack file routes, navigation links,
 * redirects, and auth flows. Renaming a value requires updating its file-route
 * contract and every external deep-link consumer in the same change.
 */
export const ROUTES = {
  HOME: "/",
  ONBOARDING: "/onboarding",
  ACCOUNT_NUX: "/account_nux",
  SETTINGS: "/settings",
  API_KEYS: "/api-keys",
  ANALYTICS: "/analytics",
  BILLING: "/billing",
  SIGN_IN: "/sign-in",
};
